import React from "react";
import './hero.css';
import { Link } from "react-router-dom";


const Hero = () => {
    return (
       <div className="hero">
            <div className="header">
                  <p>Tired of building <span>React</span> UI components<br /> from scratch?</p>
                  <h6>Discover a library of React UI components tailored <br /> to your requirements</h6>
                  <Link to='/start'>Explore Now</Link>
                  </div>
                  <a href="https://www.producthunt.com/posts/quickreact?embed=true&utm_source=badge-featured&utm_medium=badge&utm_souce=badge-quickreact" target="_blank" rel="noreferrer"><img src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=488265&theme=light" alt="QuickReact - React Component Library to Simplify Your Design Process | Product Hunt" style={{ width: '250px', height: '54px' }} /></a>
            <h1 id="save">HOW TO SAVE 3 HOURS WITH QUICKREACT</h1>
            <div className="how-easy">
              <div><a>1 . Choose 🔎</a>
               <h6>Choose from wide range<br /> of component</h6>
              </div>
              <div><a>2 . Copy 📋</a>
              <h6>copy the sorce<br /> code</h6>
              </div>
              <div><a>3 . Integrate 📌</a>
              <h6>Integrate the component <br />into  your app </h6>
              </div>
            </div>
            <iframe className="youtube" src="https://www.youtube.com/embed/-i9XiANp_8o?si=917rNyKbeZuvcuze" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
       </div>
    )
}

export default Hero;